var exports = {
  "kL": "xf0b3b88a--b9a5cc--container",
  "mF": "xf0b3b88a--b9a5cc--promo-container",
  "KQ": "xf0b3b88a--b9a5cc--photos",
};

module.exports = exports;
